import React, { useEffect } from "react";

import MapFullScreen from "./mapFullScreen";
import useMap from "../hooks/useOpenLayersMap";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";

import { ConvertCmpVolumesToFeatures, convertHexColorToRgbaColor, JumpToFeatures } from "./mapUtil";
import { useUserAuth } from "../contexts/authContext";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { Fill, Stroke } from "ol/style";
import OpenLayersInfoCard from "./mapInfoCard";

export default function ConflictionMap({ conflictedFlight, conflictionMapOpen, setConflictionMapOpen }) {
    const MAP_ID = "map-confliction";
    const map = useMap(MAP_ID, false);
    const { userMapSettings } = useUserAuth();

    useEffect(() => {
        if (!map) {
            return;
        }

        map.setTarget(document.getElementById(MAP_ID));

        const features = ConvertCmpVolumesToFeatures([conflictedFlight, ...conflictedFlight.conflicts], userMapSettings);
        for (const feature of features) {
            if (!feature.getId().includes(conflictedFlight.flight_uuid)) {
                const red = "#f44336";
                const stroke = new Stroke({ color: convertHexColorToRgbaColor(red, 1), width: 2 });
                const fill = new Fill({ color: convertHexColorToRgbaColor(red, userMapSettings.op_opacity) });
                feature.getStyle().setStroke(stroke);
                feature.getStyle().setFill(fill);
            }
        }

        const source = new VectorSource({ features });
        map.addLayer(new VectorLayer({ source, properties: { name: "flights" } }));
        JumpToFeatures(map, features);
    }, [map]);

    return (
        <Dialog open={conflictionMapOpen} onClose={() => setConflictionMapOpen(false)} fullWidth>
            <DialogTitle>Confliction Map</DialogTitle>
            <DialogContent sx={{ width: "100%", height: "500px" }}>
                <MapFullScreen map_id={MAP_ID} map={map}>
                    <OpenLayersInfoCard map={map} showButtons={false} />
                </MapFullScreen>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setConflictionMapOpen(false)}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}
